<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',

  watch: {
    '$route' () { // eslint-disable-line object-shorthand
      if (this.$route.meta.requiresAuthentication && !this.$socket.connected) {
        this.$socket.open();
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/main.scss";
</style>
